import PropTypes from 'prop-types'
import React from 'react'
import Link from 'ui/Link'

const ActivityContextLink = props => {
  const { type, properties } = props
  let href = ''
  let text = ''

  if (type === 'integration') {
    href = `/${properties.workspaceSlug}/sources/${properties.projectSlug}/integrations/${properties.integrationSlug}`
    text = properties.integrationSlug
  } else if (type === 'warehouse') {
    href = `/${properties.workspaceSlug}/warehouses/${properties.warehouseID}`
    text = properties.warehouseType
  } else if (type === 'source') {
    href = `/${properties.workspaceSlug}/sources/${properties.sourceSlug}`
    text = properties.sourceSlug
  }

  return <Link href={href} rel='external'>{text}</Link>
}

ActivityContextLink.displayName = 'ActivityContextLink'

ActivityContextLink.propTypes = {
  type: PropTypes.string.isRequired,
  properties: PropTypes.object.isRequired
}

export default ActivityContextLink



// WEBPACK FOOTER //
// ./components/ActivityContextLink.js